import { MapPinOff, CheckCircle, MapPin, Edit, Trash2, Plus } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const AddressesTab = ({ 
  user, 
  cities, 
  handleOpenAddressModal, 
  handleSetDefaultAddress, 
  handleDeleteAddress 
}) => {
  
  const getCityName = (cityId) => {
    const city = cities.find(c => c.id === parseInt(cityId));
    return city ? city.name : 'غير محدد';
  };

  return (
    <>
      <div className="flex flex-wrap justify-between items-center gap-3 mb-6">
        <h2 className="text-xl md:text-2xl font-tajawal font-bold">عناوين التوصيل</h2>
        <Button onClick={() => handleOpenAddressModal()} className="bg-brand-gold hover:bg-brand-gold/90 text-brand-black font-bold rounded-full px-4 md:px-6 gap-2 shadow-md">
          <Plus className="w-5 h-5" /> إضافة عنوان
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {(!user.addresses || user.addresses.length === 0) ? (
          <div className="col-span-full py-16 text-center bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center justify-center">
            <MapPinOff className="w-16 h-16 text-gray-300 mb-4" />
            <p className="text-gray-500 font-cairo text-lg mb-4">لا توجد عناوين مضافة حالياً</p>
            <Button onClick={() => handleOpenAddressModal()} variant="outline" className="border-burgundy-500 text-burgundy-500 hover:bg-burgundy-50 font-cairo">
              أضف عنوانك الأول
            </Button>
          </div>
        ) : (
          user.addresses.map(address => (
            <Card key={address.id} className={`p-4 md:p-6 relative transition-all duration-300 hover:shadow-md ${address.is_default ? 'border-2 border-burgundy-500 bg-burgundy-50/30' : 'border border-gray-200'}`}>
              <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6">
                <div className="shrink-0 bg-gray-100 p-3 rounded-full text-gray-500">
                  <MapPin className="w-6 h-6" />
                </div>
                <div className="flex-1 min-w-0 font-cairo">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <p className="font-bold text-lg">{getCityName(address.city_id)}</p>
                    {address.is_default && (
                      <span className="shrink-0 bg-burgundy-500 text-white text-xs px-3 py-1 rounded-full font-bold shadow-sm flex items-center gap-1">
                        <CheckCircle className="w-3 h-3" /> أساسي
                      </span>
                    )}
                  </div>
                  <p className="text-gray-700 break-words">{address.street}</p>
                  {address.building && <p className="text-gray-600 text-sm mt-1">مبنى: {address.building}</p>}
                  {address.phone && <p className="text-gray-600 text-sm mt-1">هاتف: <span dir="ltr">{address.phone}</span></p>}
                  {address.details && <p className="text-gray-500 text-sm mt-2 italic break-words">{address.details}</p>}
                </div>
              </div>
              
              <div className="flex items-center gap-3 border-t pt-4 border-gray-100">
                {!address.is_default && (
                  <button onClick={() => handleSetDefaultAddress(address.id)} className="text-sm font-cairo font-semibold text-gray-500 hover:text-burgundy-500 transition-colors">
                    تعيين كافتراضي
                  </button>
                )}
                <div className="flex-1"></div>
                <button onClick={() => handleOpenAddressModal(address)} className="p-2 text-gray-400 hover:text-blue-600 bg-gray-50 hover:bg-blue-50 rounded-full transition-colors" title="تعديل">
                  <Edit className="w-4 h-4" />
                </button>
                <button onClick={() => handleDeleteAddress(address.id)} className="p-2 text-gray-400 hover:text-red-600 bg-gray-50 hover:bg-red-50 rounded-full transition-colors" title="حذف">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </Card>
          ))
        )}
      </div>
    </>
  );
};

export default AddressesTab;
